import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'; 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/common.scss';


import VueECharts from 'vue-echarts'
import 'echarts/lib/chart/pie' // 引入饼图
import 'echarts/lib/chart/bar' // 引入柱状图/条形图
import 'echarts/lib/chart/line' // ✅ 必须加上这一行：折线图！
import 'echarts/lib/component/title' // 标题组件
import 'echarts/lib/component/tooltip' // 提示框
import 'echarts/lib/component/legend' // 图例
import 'echarts/lib/component/grid' // 网格布局（用于柱状图）
import 'echarts/lib/component/toolbox' // 工具栏（可选）

// 注册为全局组件
Vue.component('v-chart', VueECharts)



Vue.use(ElementUI);

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
